import { css } from '@emotion/react'
import { Heading, HFlow, Icon, Theme, useTheme, VFlow } from 'bold-ui'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { ConsultaSeguimentoPerguntasDiffList } from './ConsultaSeguimentoPerguntasDiffList'

export interface ConsultaSeguimentoPerguntasDiffProps {
  perguntasAnteriores: ReadonlyArray<MChatPerguntaEnum>
  perguntasAtuais: ReadonlyArray<MChatPerguntaEnum>
  perguntasObrigatorias: ReadonlyArray<MChatPerguntaEnum>
  perguntasComRespostas: ReadonlyArray<MChatPerguntaEnum>
}

export function ConsultaSeguimentoPerguntasDiff(props: Readonly<ConsultaSeguimentoPerguntasDiffProps>) {
  const { perguntasAnteriores, perguntasAtuais, perguntasObrigatorias, perguntasComRespostas } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const listOfPerguntasExcluidas = perguntasComRespostas.filter((pergunta) => !perguntasAtuais.includes(pergunta))

  return (
    <HFlow style={styles.root}>
      <VFlow vSpacing={0.5}>
        <Heading level={4}>Anterior</Heading>
        <ConsultaSeguimentoPerguntasDiffList
          listOfPerguntas={perguntasAnteriores}
          listOfPerguntasObrigatorias={perguntasObrigatorias}
          listOfPerguntasExcluidas={listOfPerguntasExcluidas}
        />
      </VFlow>
      <div css={styles.divider}>
        <div css={styles.dividerLine} />
        <Icon icon='arrowRight' size={2.5} />
        <div css={styles.dividerLine} />
      </div>
      <VFlow vSpacing={0.5}>
        <Heading level={4}>Atualizado</Heading>
        <ConsultaSeguimentoPerguntasDiffList
          listOfPerguntas={perguntasAtuais}
          listOfPerguntasObrigatorias={perguntasObrigatorias}
        />
      </VFlow>
    </HFlow>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    grid-template-columns: 1fr auto 1fr;
  `,
  divider: css`
    color: ${theme.pallete.gray.c40};
    display: grid;
    justify-items: center;
    grid-template-rows: 1fr 2.5rem 1fr;
    gap: 1rem;
  `,
  dividerLine: css`
    width: 1px;
    height: 100%;
    background-color: ${theme.pallete.divider};
  `,
})
